export const getThumbnailUrl = (video) => {
  if (video.platform === "vimeo") {
    return `https://vumbnail.com/${video.videoId}.jpg`;
  } else {
    return `https://img.youtube.com/vi/${video.videoId}/0.jpg`;
  }
};
